// extracted by mini-css-extract-plugin
export default {"inspection_date_radio_form_field":"link-to-car_inspection_date_radio_form_field__1Q-e1","inspection_date_form_field":"link-to-car_inspection_date_form_field__O9rEz"};